import React from "react";
import Navbar from './components/Navbar'
import Hero from './components/Hero'

function App() {
  return (
    <>
      <Navbar />
      <Hero />
    </>
  );
}

export default App;
